import Cookies from 'js-cookie';
import { DeleteAllCookies } from '../../Components/CommonFunctions/CommonFunctions';
import { LoggedDetailsType, Action } from './IsLoggedInterfaces';

// Define a default state
const defaultState: LoggedDetailsType = {
  isUserLogged: false,
  accessToken: '',
  tokenType: '',
  access: '',
  email: '',
  firstName: '',
  lastName: '',
  avatar: '',
  businessType: 'community',
};

// Retrieve account info from localStorage
const storedAccountInfo = localStorage.getItem('accountInfo');
const signedInObj: LoggedDetailsType = storedAccountInfo
  ? JSON.parse(storedAccountInfo)
  : defaultState;

// Check for an auth token in cookies
const accessToken = Cookies.get('authToken');
if (accessToken) {
  signedInObj.accessToken = accessToken;
  signedInObj.isUserLogged = true;
}

const loggedReducer = (
  state: LoggedDetailsType = signedInObj,
  action: Action,
): LoggedDetailsType => {
  switch (action.type) {
    case 'USER_AUTHENTICATED': {
      const info: LoggedDetailsType = {
        isUserLogged: action.payload.isUserLogged,
        accessToken: action.payload.accessToken,
        tokenType: action.payload.tokenType,
        access: action.payload.access,
        email: action.payload.email,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        avatar: action.payload.avatar,
        businessType: action.payload.businessType,
      };
      localStorage.setItem('accountInfo', JSON.stringify(info));
      return info;
    }

    case 'RESET_USER': {
      const keysToKeep = ['workspaceId', 'playbookId'];

      // Store their values temporarily
      const tempStorage: { [key: string]: string } = {};
      keysToKeep.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value !== null) {
          tempStorage[key] = value;
        }
      });

      localStorage.clear();

      Object.keys(tempStorage).forEach((key) => {
        if (tempStorage[key]) localStorage.setItem(key, tempStorage[key]);
      });

      localStorage.setItem('isLoggingOut', 'true');
      DeleteAllCookies();
      localStorage.setItem('accountInfo', JSON.stringify(defaultState));
      return defaultState;
    }

    case 'UPDATE_TOKEN': {
      const updatedState: LoggedDetailsType = {
        ...state,
        accessToken: action.payload,
      };
      localStorage.setItem('accountInfo', JSON.stringify(updatedState));
      localStorage.setItem('accessToken', action.payload);

      const domain = window.location.hostname.split('.').slice(-2).join('.');

      Cookies.set('authToken', action.payload, {
        sameSite: 'None',
        secure: true,
        domain,
        path: '/',
        expires: import.meta.env.VITE_MODE === 'dev' ? 1 / 24 : 15 / 1440,
      });

      return updatedState;
    }

    default:
      return state;
  }
};

export default loggedReducer;
